import React from "react";

const Consumer_Generator_Past = () => {
  return <div>Consumer_Generator_Past</div>;
};

export default Consumer_Generator_Past;
